import { combineReducers } from "@reduxjs/toolkit";
import donation from "./donation";
import checkout from "./checkout";
import auth from "./auth";

export const rootReducer = combineReducers({
    DonationInfo: donation,
    CheckoutInfo: checkout,
    AuthInfo: auth
});